/* XTR • XO.SKLTN Finder — Brand → Model → Results (topper + accessories).
   Standalone, initialises every .xsf-finder on the page. Per-section config is
   read from a <script type="application/json" class="xsf-cfg"> inside the root. */
(function(){
  function init(root){
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('.xsf-cfg').textContent); } catch(e){}
    var LIMIT = cfg.limit || 250;
    var ACC = cfg.acc || 'xo-skltn-accessories';
    var LINK_BASE = cfg.linkBase || '';
    while (LINK_BASE.slice(-1) === '/') LINK_BASE = LINK_BASE.slice(0, -1);
    var SK = ['SKLTN','XO.SKLTN','XOSKLTN'];

    var state = { brand:'', bname:'', collection:'', key:'', model:'' };
    var panels = root.querySelectorAll('.fpanel');
    var steps = root.querySelectorAll('.fstep li');
    var back = root.querySelector('.fback');
    var crumb = root.querySelector('.fcrumb');
    var topperGrid = root.querySelector('[data-for="topper"]');
    var accGrid = root.querySelector('[data-for="acc"]');
    var accGroup = root.querySelector('.fgroup[data-group="acc"]');
    var more = root.querySelector('.fmore');
    var reached = 1;

    function up(s){ return String(s||'').toUpperCase(); }
    function esc(s){ return (s||'').replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
    function show(step){
      panels.forEach(function(p){ p.hidden = (+p.dataset.step !== step); });
      steps.forEach(function(li){ var s=+li.dataset.goto; li.classList.toggle('on', s===step); li.classList.toggle('done', s<step); });
      back.hidden = step===1;
      reached = Math.max(reached, step);
      crumbUpdate();
      try { root.scrollIntoView({behavior:'smooth', block:'start'}); } catch(e){}
    }
    function crumbUpdate(){
      var parts=[];
      if(state.bname) parts.push('<b>'+esc(state.bname)+'</b>');
      if(state.model) parts.push('<b>'+esc(state.model)+'</b>');
      crumb.innerHTML = parts.join(' &nbsp;/&nbsp; ');
    }

    root.querySelectorAll('.fcard.brand').forEach(function(b){
      b.addEventListener('click', function(){
        state.brand = b.dataset.brand;
        state.bname = b.querySelector('.fname').textContent.trim();
        state.collection = b.dataset.collection || '';
        state.key=''; state.model='';
        root.querySelectorAll('.fcard.model').forEach(function(m){ m.hidden = (m.dataset.brand !== state.brand); });
        show(2);
      });
    });
    root.querySelectorAll('.fcard.model').forEach(function(m){
      m.addEventListener('click', function(){
        state.key = up(m.dataset.key); state.model = m.dataset.name;
        if(m.dataset.collection) state.collection = m.dataset.collection;
        show(3); load();
      });
    });
    back.addEventListener('click', function(){
      var cur=1; steps.forEach(function(li){ if(li.classList.contains('on')) cur=+li.dataset.goto; });
      if(cur>1) show(cur-1);
    });
    steps.forEach(function(li){
      li.addEventListener('click', function(){ var s=+li.dataset.goto; if(s<reached || li.classList.contains('done')) show(s); });
    });

    function money(v){ var n=parseFloat(v||0); if(isNaN(n)) return ''; return '$'+n.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}); }
    function cleanTitle(t){
      return (t||'')
        .replace(/^\s*z[-\s]+/i,'')
        .replace(/\s*\|.*$/,'')
        .replace(/^XO\.?SKLTN\s+/i,'')
        .replace(/^All-In-One Topper System\s*[-–—]\s*/i,'')
        .trim();
    }
    function img(p){ var src=(p.images && p.images[0] && p.images[0].src) || p.featured_image || ''; if(!src) return ''; return src + (src.indexOf('?')>-1?'&':'?') + 'width=600'; }
    function minPrice(p){ if(!p.variants || !p.variants.length) return null; var m=null; p.variants.forEach(function(v){ var n=parseFloat(v.price); if(!isNaN(n)&&(m===null||n<m)) m=n; }); return m; }
    function byPrice(a,b){ var pa=minPrice(a), pb=minPrice(b); return (pa===null?1e12:pa)-(pb===null?1e12:pb); }
    function dedupe(items){ var seen={}; return items.filter(function(p){ if(seen[p.handle]) return false; seen[p.handle]=1; return true; }); }
    function isSkltn(p){
      var t=up(p.product_type), title=up(p.title), tags=(p.tags||[]).map(up);
      return SK.some(function(k){ return t.indexOf(k)>-1 || title.indexOf(k)>-1 || tags.some(function(tg){ return tg.indexOf(k)>-1; }); });
    }
    function isHidden(p){
      var t=up(p.product_type), title=up(p.title), tags=(p.tags||[]).map(up);
      return t==='ODOO_HIDDEN' || tags.indexOf('ODOO_HIDDEN')>-1 || title.indexOf('TEST OF')===0;
    }
    function isTopper(p){
      if(!isSkltn(p) || isHidden(p)) return false;
      var t=up(p.product_type), title=up(p.title);
      var isSystem = t==='XO.SKLTN' || title.indexOf('ALL-IN-ONE')>-1 || title.indexOf('TOPPER SYSTEM')>-1;
      if(!isSystem) return false;
      return title.indexOf(state.key)>-1;
    }
    function accVisible(p){
      if(isHidden(p)) return false;
      var title=up(p.title);
      var modelSpecific = /ADD[- ]?ON KIT\s*-\s*\S/.test(title);
      if(modelSpecific) return title.indexOf(state.key)>-1;
      return true;
    }

    function fetchCol(handle){
      return fetch('/collections/'+encodeURIComponent(handle)+'/products.json?limit='+LIMIT, {headers:{'Accept':'application/json'}})
        .then(function(r){ if(!r.ok) throw new Error('http '+r.status); return r.json(); })
        .then(function(d){ return d.products || []; });
    }
    function pcard(p, cls){
      var mp=minPrice(p), multi=p.variants && p.variants.length>1, im=img(p);
      var price = mp===null ? '' : '<div class="pprice">'+(multi?'<span class="from">From</span>':'')+money(mp)+'</div>';
      return '<a class="pcard'+(cls?' '+cls:'')+'" href="'+LINK_BASE+'/products/'+p.handle+'">'+
        (im?'<img class="pimg" src="'+im+'" alt="'+esc(p.title)+'" loading="lazy">':'<div class="pimg"></div>')+
        '<div class="pbody"><div class="ptitle">'+esc(cleanTitle(p.title))+'</div>'+price+
        '<span class="pcta">View Details</span></div></a>';
    }
    function setCount(which,n){ var el=root.querySelector('[data-count="'+which+'"]'); if(el) el.textContent = n ? (n+(n===1?' item':' items')) : ''; }

    function load(){
      topperGrid.innerHTML = '<div class="fspin"><i></i> Loading your '+esc(state.model)+' XO.SKLTN…</div>';
      accGrid.innerHTML=''; accGroup.hidden=true; more.innerHTML=''; setCount('topper',0); setCount('acc',0);
      Promise.all([ fetchCol(state.collection), fetchCol(ACC) ]).then(function(res){
        var toppers = dedupe(res[0].filter(isTopper)).sort(byPrice);
        var accs = dedupe(res[1].filter(accVisible)).sort(byPrice);
        render(toppers, accs);
      }).catch(function(){
        topperGrid.innerHTML = '<div class="fmsg">We couldn’t load products just now.<br><a href="'+LINK_BASE+'/collections/'+encodeURIComponent(state.collection||'xo-skltn')+'">Browse '+esc(state.bname)+' XO.SKLTN &rarr;</a></div>';
      });
    }
    function render(toppers, accs){
      if(!toppers.length){
        topperGrid.innerHTML = '<div class="fmsg">The XO.SKLTN for the '+esc(state.model)+' isn’t listed yet.<br><a href="'+LINK_BASE+'/collections/'+encodeURIComponent(state.collection||'xo-skltn')+'">See all '+esc(state.bname)+' XO.SKLTN &rarr;</a></div>';
      } else {
        topperGrid.innerHTML = toppers.map(function(p){ return pcard(p,'topper'); }).join('');
        setCount('topper', toppers.length);
      }
      if(accs.length){
        accGroup.hidden=false;
        accGrid.innerHTML = accs.map(function(p){ return pcard(p,''); }).join('');
        setCount('acc', accs.length);
      }
      more.innerHTML = '<a href="'+LINK_BASE+'/collections/'+encodeURIComponent(ACC)+'">Browse all XO.SKLTN accessories &rarr;</a>';
    }
  }
  var roots = document.querySelectorAll('.xsf-finder');
  for(var i=0;i<roots.length;i++) init(roots[i]);
})();
